/**
 * Team Inbox — full-screen media viewer (UI Spec §7.2 photo/video "tap →
 * full-screen viewer"). Phase 1: single-item view with caption + close
 * (Esc / tap-out / ✕). Swipe-between-media lands with the Capacitor
 * phase.
 */
import { useEffect } from 'react';
import type { InboxMessage } from '../lib/types';

export function MediaViewer({
  m,
  onClose,
}: {
  m: InboxMessage;
  onClose: () => void;
}) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const url = m.attachment?.downloadURL;
  if (!url) return null;

  return (
    <div
      className="ti-viewer"
      role="dialog"
      aria-modal="true"
      aria-label="Media viewer"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <button
        type="button"
        className="ti-viewer-close"
        onClick={onClose}
        aria-label="Close viewer"
      >
        ✕
      </button>
      {m.kind === 'video' ? (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video src={url} controls autoPlay />
      ) : (
        <img src={url} alt={m.attachment?.fileName || 'media'} />
      )}
      {(m.body || m.attachment?.fileName) && (
        <span className="cap">{m.body || m.attachment?.fileName}</span>
      )}
    </div>
  );
}
